import { AuthAuthPermissions } from '@robovision/rvai-auth'
import type { RvaiAbilityBuilder } from '../types'


export function defineResourcesAbility (
  builder: RvaiAbilityBuilder,
  permissions: AuthAuthPermissions[],
): void {
  const { can } = builder

  permissions.some(p => p === AuthAuthPermissions.SYSTEM_MANAGEMENT) && can('crud', 'Resource')
  permissions.some(p =>
    p === AuthAuthPermissions.INFERENCE ||
    p === AuthAuthPermissions.MODEL_CREATION) && can('read', 'Resource')
}
